import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  const socialLinks = [
    { icon: '🎬', label: 'Youtube', url: 'https://www.youtube.com/@extraterrestrialtools' },
    { icon: '📧', label: 'Email', url: 'mailto:contact@extraterrestrialtools.com' },
    { icon: '🔗', label: 'LinkedIn', url: '#' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <motion.p 
          className="footer-text"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          Built by a human from Earth, powered by alien technology 👽
        </motion.p>
        
        <motion.div 
          className="social-links"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {socialLinks.map((link, index) => (
            <motion.a
              key={index}
              href={link.url}
              className="social-link"
              aria-label={link.label}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 + index * 0.1, duration: 0.5 }}
              whileHover={{ 
                scale: 1.2, 
                y: -5,
                rotate: [0, -10, 10, 0],
                transition: { duration: 0.4 }
              }}
              whileTap={{ scale: 0.9 }}
            >
              {link.icon}
            </motion.a>
          ))}
        </motion.div>

        {/* Legal Links */}
        <motion.div 
          className="legal-links"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <Link 
            to="/imprint"
            className="legal-link"
            style={{
              color: '#64ffda',
              textDecoration: 'none',
              fontSize: '0.9rem',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
          >
            Imprint
          </Link>
          <span className="legal-separator" style={{ color: '#666', margin: '0 1rem' }}>|</span>
          <Link 
            to="/privacy"
            className="legal-link"
            style={{
              color: '#64ffda',
              textDecoration: 'none',
              fontSize: '0.9rem',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
          >
            Privacy Policy
          </Link>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.8, duration: 1 }}
          style={{
            marginTop: '40px',
            padding: '20px',
            borderRadius: '15px',
            background: 'rgba(0, 255, 136, 0.05)',
            border: '1px solid rgba(0, 255, 136, 0.1)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <div style={{ 
            color: '#00ff88', 
            fontSize: '0.9rem', 
            fontWeight: '600',
            marginBottom: '8px'
          }}>
            🚀 Ready to launch your own cosmic tool?
          </div>
          <div style={{ 
            color: '#a0a0a0', 
            fontSize: '0.85rem' 
          }}>
            Contact us to add your tool to the ExtraterrestrialTools directory
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;